import { CarouselSection } from '@app/components/CarouselSection';
import { constants, Skeleton, Stack } from '@redbubble/design-system';
import chunk from 'lodash/chunk';

export const getProductFeedSkeleton = () => {
  const chunkSize = 2;
  const skeletons = Array.from({ length: 10 }, (_, i) => i);
  return chunk(skeletons, chunkSize).map((skeleton, outerIndex) => (
    <CarouselSection.CarouselSlide
      // biome-ignore lint/suspicious/noArrayIndexKey: noArrayIndexKey
      key={`product-feed-skeleton-slide-${outerIndex}`}
    >
      {skeleton.map((_, innerIndex) => (
        <CarouselSection.CarouselSlide
          // biome-ignore lint/suspicious/noArrayIndexKey: noArrayIndexKey
          key={`product-feed-skeleton-${outerIndex}-${innerIndex}`}
        >
          <div data-testid="product-feed-skeleton">
            <Stack spacing="s">
              <Skeleton
                ratio={constants.RATIO_SQUARE}
                animated
                roundedCorners
              />

              <Skeleton
                height={8 * 2}
                width={8 * 7 + 8 * (8 * Math.random())}
                animated
                roundedCorners
              />

              <Skeleton
                height={8 * 3}
                width={8 * 8 + 8 * (8 * Math.random())}
                animated
                roundedCorners
              />
            </Stack>
          </div>
        </CarouselSection.CarouselSlide>
      ))}
    </CarouselSection.CarouselSlide>
  ));
};
